import styled from 'styled-components';

import { gridSizes } from 'utils/style';

import Description from 'components/RecurringOrderSuggestionsDiscardReasonsModal/Sections/Description/component';

export default styled(Description)`
  p {
    font-size: ${gridSizes('M')};
    line-height: 21px;
    color: var(--grey700);
  }
`;
